<template>
  <v-row
    class="background-color-white z-index-2"
    :class="{ 'position-fixed': fixed }"
  >
    <v-col cols="12">
      <component
        :is="useScrollSpy ? 'scrollactive' : 'div'"
        v-bind="useScrollSpy ? scrollactiveProps : {}"
        v-on="useScrollSpy ? { itemchanged: onItemChanged } : {}"
      >
        <v-sheet :width="innerWidth">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
              class="d-flex justify-center"
              v-for="(items, section, index) in menuItems"
              :key="section"
            >
              <v-btn
                :id="index"
                :class="{
                  'active-side-nav': !useScrollSpy && section === selectedSection,
                }"
                class="scrollactive-item"
                @click="offsetAtHeader"
                rounded
                :to="
                  websiteFormat === 'all_items'
                    ? `#${slug(section.replace(/^\d/, 'abc$&'))}`
                    : { name: 'home', hash: `#${slug(section)}` }
                "
                width="85"
                depressed
              >
                <h4
                  class="font-weight-medium no-uppercase section-name-max-width text-truncate"
                >
                  {{ section }}
                </h4>
              </v-btn>
            </swiper-slide>
          </swiper>
        </v-sheet>
      </component>
    </v-col>
  </v-row>
</template>

<script>
import { slug } from "github-slugger";
import { mapGetters, mapState } from 'vuex';

const offset = { click: 260, init: 64, scroll: 440 };

export default {
  name: "NavigationSwiper",
  computed: {
    scrollactiveProps() {
      return {
        'active-class': 'active-side-nav',
        highlightFirstItem: true,
        modifyUrl: true,
        offset: this.offset,
      };
    },
    swiper() {
      return this.$refs.mySwiper?.$swiper;
    },
    ...mapGetters('menu', ['selectedSection']),
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
    useScrollSpy() {
      return this.websiteFormat !== 'menu_only';
    },
  },
  watch: {
    selectedSection(val) {
      this.slideToSelectedSection(val);
    },
  },
  created() {
    window.addEventListener("scroll", this.setOffset);
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      offset: offset.init, // init important when clicking from home carousel
      swiperOptions: {
        slidesPerView: 3.2,
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.setOffset);
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    offsetAtHeader() {
      this.offset = offset.click;
    },
    onItemChanged(event, currentItem) {
      if (!currentItem) {
        return;
      }

      this.swiper.slideTo(currentItem.id, 400, false);
      this.offset = offset.scroll;
    },
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    setOffset() {
      this.offset = offset.scroll;
    },
    slideToSelectedSection(val) {
      if (!this.useScrollSpy && val && this.menuItems) {
        const index = Object.keys(this.menuItems).indexOf(val);

        if (index !== -1 && this.swiper) {
          this.swiper.slideTo(index);
        }
      }
    },
    slug,
  },
  mounted() {
    this.slideToSelectedSection(this.selectedSection);
    /*
      scrollactive's offset acts crazy
      doesn't seem to activate unless past the anchor
      so the scroll event is necessary on load
      it changes the init position (correct UI placement)
      to scroll position (necessary programmatic placement)
    */
    setTimeout(() => {
      window.removeEventListener("scroll", this.setOffset);
    }, 1000);
  },
  props: { fixed: Boolean, menuItems: Object },
};
</script>

<style scoped>
.active-side-nav {
  background-color: var(--v-primary-base) !important;
  color: var(--color-white) !important;
}

.position-fixed {
  position: fixed;
  /*top: 194px;*/
  top: 197px;
}

.section-name-max-width {
  max-width: 100px;
}

.z-index-2 {
  z-index: 2;
}
</style>
